module.exports = __webpack_public_path__ + "img/dlt_kind_1.1cb98a9b.png";